import { render, staticRenderFns } from "./site-panel.vue?vue&type=template&id=197e68b2&scoped=true"
import script from "./site-panel.vue?vue&type=script&lang=js"
export * from "./site-panel.vue?vue&type=script&lang=js"
import style0 from "./site-panel.vue?vue&type=style&index=0&id=197e68b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197e68b2",
  null
  
)

export default component.exports